import { useState, useCallback } from "react";

export type StoryStep =
  | "LOADER"
  | "COUNTER"
  | "UNLOCK"
  | "SUCCESS"
  | "HERO"
  | "TIME"
  | "LETTER"
  | "MEANING"
  | "SURPRISE"
  | "VIDEO"
  | "FOREVER"
  | "CLOSURE";

const STORY_FLOW: StoryStep[] = [
  "LOADER",
  "COUNTER",
  "UNLOCK",
  "SUCCESS",
  "HERO",
  "TIME",
  "LETTER",
  "MEANING",
  "SURPRISE",
  "VIDEO",
  "FOREVER",
  "CLOSURE",
];

export const useStoryboard = (initialStep: StoryStep = "LOADER") => {
  const [currentStep, setCurrentStep] = useState<StoryStep>(initialStep);

  const nextStep = useCallback(() => {
    const currentIndex = STORY_FLOW.indexOf(currentStep);
    if (currentIndex < STORY_FLOW.length - 1) {
      setCurrentStep(STORY_FLOW[currentIndex + 1]);
    }
  }, [currentStep]);

  const previousStep = useCallback(() => {
    const currentIndex = STORY_FLOW.indexOf(currentStep);
    if (currentIndex > 0) {
      setCurrentStep(STORY_FLOW[currentIndex - 1]);
    }
  }, [currentStep]);

  const goToStep = useCallback((step: StoryStep) => {
    setCurrentStep(step);
  }, []);

  const restartStory = useCallback(() => {
    setCurrentStep("LOADER");
  }, []);

  return {
    currentStep,
    nextStep,
    previousStep,
    goToStep,
    restartStory,
  };
};
